import { ButtonProps } from '@mui/material/Button';
import { PropsWithChildren, useRef } from 'react';
import LoadingButton from '../buttons/LoadingButton';

type FileButtonProps = Omit<ButtonProps, 'onChange'> & {
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  acceptedFiles?: string;
  multiple?: boolean;
  isLoading: boolean;
};

const FileButton: React.FC<PropsWithChildren<FileButtonProps>> = ({
  children,
  onChange,
  acceptedFiles = 'image/jpeg,image/png,image/gif',
  multiple = false,
  isLoading,
  ...props
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const onPhotoButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      onChange(event);
    }
    event.currentTarget.value = '';
  };

  return (
    <>
      <input
        accept={acceptedFiles}
        style={{ display: 'none' }}
        id="file-upload"
        ref={fileInputRef}
        type="file"
        multiple={multiple}
        onChange={handleFileChange}
      />
      <LoadingButton
        {...props}
        loading={isLoading}
        disabled={isLoading}
        onClick={onPhotoButtonClick}
      >
        {children}
      </LoadingButton>
    </>
  );
};

export default FileButton;
